module.exports = __webpack_public_path__ + "static/media/modalBuddies.d033accb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/modalBuddies.png
// module id = 605
// module chunks = 0